module.exports = __webpack_public_path__ + "media/components/Influencers/Oauths/New/StepPage/step1_2-284504fb1ec5f57959842331ec37b1b6.png";